<template lang="pug">
  div
    header-without-menu
    div.content.access.join(:class="{loaded}")
      div.center-form.join-form
        div.text-center
          //div: img(src="../../../assets/logo_big.svg")
        b-row
          b-card.w-100
            div.auth-status(:class="code")
              icon(:name="state", :spin="state === 'spinner'", scale="4")
            div.message(v-html="$t(`email-auth-${code}`)")
            div.button-wrap
              b-btn.w-100(variant="primary", :to="{name: 'login'}") {{$t('go_login')}}
</template>

<script>
import {checkAuth} from '@/api/access'
import { HeaderWithoutMenu } from '../../mixins/header'
export default {
  name: 'welcome-component',
  components: { HeaderWithoutMenu },
  mounted () {
    this.loaded = true

    const {type, key} = this.$route.query
    if (!type || !key) {
      this.$router.push({name: 'error', params: {code: 400}})
      return
    }

    checkAuth(key)
      .then(resp => {
        const code = resp.result.toLowerCase()
        this.code = code
        if (code === 'fail') {
          this.state = 'exclamation-triangle'
        } else if (code === 'already') {
          this.state = 'check-circle'
        } else if (code === 'success') {
          this.state = 'check-circle'
        } else {

        }
      })
  },
  data () {
    return {
      loaded: false,
      state: 'spinner',
      code: 'wait'
    }
  }
}
</script>

<style lang="scss" scoped src="../access.scss"></style>
<style lang="scss" scoped>
.loaded .join-form {
  margin-top: 20px;
}

.auth-status {
  padding-top: 30px;
  text-align: center;
  transition: color 300ms;
  &.spinner {
    color: grey;
  }
  &.success {
    color: #3fc13f;
  }
  &.already {
    color: grey;
  }
  &.fail {
    color: #d64b4b;
  }
}

.message {
  font-size: 24px;
  color: #888;
  text-align: center;
  padding: 20px 0 40px;
}
</style>
